import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getPagePath, withLocales } from '@spotahome/bff/client';
import { localesShape } from '@spotahome/bff/shapes';
import Metrics from '@spotahome/soyuz-metrics';

import LanguageSwitcher from './language-switcher-menu';

class LanguageSwitcherMenuContainer extends Component {
  static contextTypes = {
    server: PropTypes.shape({
      currentRoute: PropTypes.string
    }),
    request: PropTypes.shape({
      baseUrl: PropTypes.string,
      path: PropTypes.string,
      params: PropTypes.obj,
      loginError: PropTypes.array
    })
  };

  static defaultProps = {
    abbreviated: false
  };

  static propTypes = {
    abbreviated: PropTypes.bool,
    locales: PropTypes.shape(localesShape).isRequired
  };

  handlerOnChange = localeSelected => {
    Metrics.ga.sendEvent('i18n', 'language-switcher', localeSelected);
    this.updateUrl(localeSelected);
  };

  updateUrl(locale) {
    const queryString = window.location.search;
    const currentRoute = this.context.server.currentRoute;
    const params = this.context.request.params;

    window.location =
      getPagePath(currentRoute, { locale, params }) + queryString;
  }

  render() {
    return (
      <LanguageSwitcher
        supported={this.props.locales.ui}
        languageSelected={this.props.locales.current}
        onChange={this.handlerOnChange}
        abbreviated={this.props.abbreviated}
      />
    );
  }
}

export default withLocales()(LanguageSwitcherMenuContainer);
